import 'regenerator-runtime';
import 'core-js';

import Featherify from './plugins/Featherify';

window.featherify = new Featherify({
    contentContainerSelector: '.content-area',
}).listen();
